module.exports = __webpack_public_path__ + "static/media/logo_vietinbank.5d3fcb08.svg";